import { graphql } from "@/gql";

export const INCIDENT_TYPE_QUERY = graphql(`
  query INCIDENT_TYPE_QUERY($id: String!) {
    incidentType(id: $id) {
      id
      name
      description
      category
      allowlist
      iconSvg
      iconPng
      allowDroneEndpoint
      shortId
      icon
      color
      dataSchema
      uiSchema
      useAllowlist
    }
  }
`);
